var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Tiles } from "./tiles";
export class Focus {
    constructor(layout) {
        this.layout = layout;
        this.ratio = 1;
        this.tiles = null;
        this.lastLayout = { area: 1, columnar: false };
        this.animPending = false;
        this.maximize = false;
        this.width = this.layout.options.width;
        this.height = this.layout.options.height;
        this.maximize = this.layout.options.focus.maximize;
    }
    contains(div) {
        return this.tiles && this.tiles.contains(div);
    }
    /** fill available space given constraints */
    fillSpace(maxWidth, maxHeight, minWidth, minHeight) {
        let height = maxHeight;
        let width = this.ratio * height;
        if (width > maxWidth) {
            width = maxWidth;
            height = width / this.ratio;
        }
        if (width < minWidth) {
            width = minWidth;
        }
        if (height < minHeight) {
            height = minHeight;
        }
        return {
            area: width * height,
            width,
            height,
        };
    }
    /** select between horizontal or vertical split */
    findLayout() {
        const columns = Object.assign({ columnar: true }, this.fillSpace(this.width * Focus.MAX, this.height, this.width * Focus.MIN, this.height * Focus.MIN));
        const rows = Object.assign({ columnar: false }, this.fillSpace(this.width, this.height * Focus.MAX, this.width * Focus.MIN, this.height * Focus.MIN));
        const largest = rows.area > columns.area ? rows : columns;
        const sameOld = this.lastLayout.columnar ? columns : rows;
        return largest.area / sameOld.area > 1.025 ? largest : sameOld;
    }
    set(div, ratio) {
        this.ratio = ratio;
        if (!this.tiles) {
            this.tiles = new Tiles(this.layout);
        }
        this.tiles.tile(div, ratio);
        this.update();
    }
    unset() {
        var _a;
        this.layout.tiles.reset();
        this.layout.tiles.update({
            width: this.width,
            height: this.height,
            top: 0,
        });
        (_a = this.tiles) === null || _a === void 0 ? void 0 : _a.untile(this.tiles.boxes[0].elm);
        this.tiles = null;
    }
    update(options = {}) {
        var _a, _b;
        this.width = options.width || this.width;
        this.height = options.height || this.height;
        this.maximize = (_b = (_a = options.focus) === null || _a === void 0 ? void 0 : _a.maximize) !== null && _b !== void 0 ? _b : this.maximize;
        if (!this.tiles) {
            return;
        }
        if (this.maximize) {
            this.tiles.update({
                width: this.width,
                height: this.height,
            });
            return;
        }
        const layout = this.findLayout();
        this.layout.tiles.reset();
        if (layout.columnar) {
            this.layout.tiles.update({
                width: this.width - layout.width,
                height: this.height,
                top: 0,
            });
        }
        else {
            this.layout.tiles.update({
                width: this.width,
                height: this.height - layout.height,
                top: layout.height,
            });
        }
        this.tiles.update(Object.assign({ width: layout.columnar
                ? layout.width + this.layout.options.margin
                : this.width, height: layout.columnar
                ? this.height
                : layout.height + this.layout.options.margin }, (layout.columnar
            ? { left: this.width - layout.width - this.layout.options.margin }
            : { left: 0 })));
        if (layout.columnar !== this.lastLayout.columnar) {
            this.animPending = true;
        }
        this.lastLayout = layout;
    }
    render(animate = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.tiles) {
                yield this.tiles.render(animate || this.animPending);
            }
            this.animPending = false;
        });
    }
}
Focus.MAX = 0.75;
Focus.MIN = 0.5;
